'use client';
import Link from 'next/link';
import DynamicImage from '@/components/DynamicImage';
import { motion } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';
// import { AnimatedButton } from './common/AnimatedButton';
// import RegisDialog from './regisDialog';

const Contentonemobile = () => {
  const items = [
    {
      title: 'SCRM系统是必须的吗？',
      dsc: '私域的核心聚焦于营销运营上，且需要经验不断累积，然而这些能力在市场上处于稀缺状态。微友智汇SCRM 系统可有效的将营销各个板块进行标准化和流程化处理，为企业私域运营赋能。营销的关键要点在于找到恰当的人、相符的产品以及行之有效的触达手段，与企业适配的 SCRM 能够以标准化的方式推进私域运营落地。',
    },
    {
      title: '私域是什么？真的有效吗？',
      dsc: '私域并不仅仅局限于流量，它更是当下数字化市场中的一种全新运营思维。在当前流量成本急剧上涨以及竞品如红海般的时代，对企业私域用户进行有效的运营，能够帮助企业降低对新流量的依赖程度，提高首购率，促成复购，从而为企业实现降本增效的目标。',
    },
    {
      title: '微友智汇的SCRM适合我们吗？',
      dsc: '微友智汇 SCRM 是一套从业务实战中积累而来的系统。我们认为只有契合企业业务需求的系统，才是有价值的系统。微友智汇 SCRM 的全场景全链路 SaaS 产品会根据企业的业务模式进行适配，并提供陪跑赋能服务，为实现企业的业务增长目标全力以赴。',
    },
  ];

  const [nowNUm, setNowNUm] = useState(1);
  const domWidth = useRef(0);
  const scrollContainerRef = useRef<any>(null);
  const scrollDomRef = useRef<any>(null);
  const handleScroll = () => {
    if (scrollContainerRef.current) {
      const scrollLeft = scrollContainerRef.current.scrollLeft;
      if (scrollLeft > Math.floor(domWidth.current / 2)) {
        setNowNUm(3);
      } else if (
        scrollLeft <= Math.floor(domWidth.current / 2) &&
        scrollLeft > Math.floor(domWidth.current / 5)
      ) {
        setNowNUm(2);
      } else {
        setNowNUm(1);
      }
    }
  };

  useEffect(() => {
    const container = scrollContainerRef.current;
    container.addEventListener('scroll', handleScroll);
    return () => {
      container.removeEventListener('scroll', handleScroll);
    };
  }, []);

  useEffect(() => {
    const scrollDom = scrollDomRef.current;
    domWidth.current = scrollDom.offsetWidth;
  }, []);
  return (
    <section className="w-full">
      <motion.div
        className="text-center mb-8"
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
      >
        <h2 className="text-[18px] mt-[32px] font-medium text-black/85">企业对私域的疑惑</h2>
        <div ref={scrollContainerRef} className="overflow-x-auto scrollBar scrollBar1">
          <div ref={scrollDomRef} className="mt-[16px] px-[10%] w-[270%] flex">
            {items.map((item, index) => (
              <div
                key={index}
                className={`bg-[url('https://osscdn.weiyouzhihui.com/editorVideo/1736412620360/image%201942%402x.png')] w-[80%] h-[267px] bg-top bg-no-repeat relative ${index === 1 ? 'mx-[16px]' : ''}`}
                style={{ backgroundSize: '100% 100%' }}
              >
                <DynamicImage
                  src="https://osscdn.weiyouzhihui.com/editorVideo/1736413149459/image%201920%402x.png"
                  className="w-[94px] h-[80px] absolute top-[20px] right-[10px]"
                ></DynamicImage>
                <p className="pl-[16px] h-[78px] text-left text-[#fff] pr-[120px] flex items-center">
                  {item.title}
                </p>
                <p className="text-[13px] text-left px-[16px] pt-[20px] leading-[21px]">
                  {item.dsc}
                </p>
              </div>
            ))}
          </div>
        </div>
        <div className="flex justify-center pt-[16px]">
          {[1, 2, 3].map(item => (
            <p
              key={item}
              className={`h-[4px] rounded-[19px] ${item === 2 ? 'mx-[8px]' : ''} ${nowNUm === item ? 'w-[20px] bg-[#FF6700]' : 'w-[10px] bg-[rgba(0,0,0,0.2)]'}`}
            ></p>
          ))}
        </div>
      </motion.div>
    </section>
  );
};

export default Contentonemobile;
